import * as types from './mutation-types'

const state = {
  memberships: {
    data: [],
  },
  selectedMemberships: [],
  membership: {
    subscription: {},
  },
  membershipGroups: {
    data: [],
    meta: {
      pagination: {},
    },
  },
  accessRequestApprovalQueue: [],
  pendingAccessRequests: {
    data: [],
  },
  createMembershipGroupModal: {
    open: false,
  },
  addMembersToMembershipGroupModal: {
    open: false,
    membershipGroup: null,
  },
  editMembershipGroupModal: {
    open: false,
    membershipGroup: null,
  },
  deleteMembershipGroupModal: {
    open: false,
    membershipGroup: null,
  },
  membershipGroupTypes: [],
  uploadMemberCSVModal: {
    open: false,
  },
  memberCSVUploadApprovalQueue: {
    rows: [],
    meta: {},
  },
  // See PhoneNumber.php for the constant definitions of available types
  phoneNumberTypes: [
    {
      id: 1,
      label: 'Mobile',
    },
    {
      id: 2,
      label: 'Home',
    },
  ],
  // See app/config/members.php for definitions of emergency contact types
  emergencyContactTypes: [
    'spouse',
    'sibling',
    'parent',
    'other',
  ],
  // See constants in Address.php for available types
  addressTypes: [
    {
      id: 1,
      label: 'Mailing',
    },
    {
      id: 2,
      label: 'Billing',
    },
  ],
  removeMembershipFromMembershipGroupModal: {
    membershipUuid: null,
    membershipGroup: null,
    open: false,
  },
  deactivateMembershipModal: {
    membership: null,
    open: false,
  },
  reactivateMembershipModal: {
    membership: null,
    open: false,
  },
  deleteMembershipModal: {
    membership: null,
    open: false,
  },
  inviteMembershipModal: {
    membership: null,
    open: false,
  },
  membershipReports: {
    running: false,
    data: [],
    availableColumns: [],
    availableFilters: [],
  },
  membershipReport: {},
}

const mutations = {
  [types.MEMBERSHIP_SET_CSV_ROWS_ON_APPROVAL_QUEUE](state, rows) {
    state.memberCSVUploadApprovalQueue.rows = rows.data.map(row => ({
      ...row,
      invite: true,
      groups: [],
      role: 'union-member',
    }))
    state.memberCSVUploadApprovalQueue.meta = rows.meta
  },
  [types.MEMBERSHIP_RESET_MEMBER_CSV_APPROVAL_QUEUE](state) {
    state.memberCSVUploadApprovalQueue = {
      rows: [],
      meta: {},
    }
  },
  [types.MEMBERSHIP_PUSH_CSV_ROW_ONTO_APPROVAL_QUEUE](state, Row) {
    let index = _.findIndex(state.memberCSVUploadApprovalQueue.rows, { uuid: Row.uuid })

    if (index === -1) {
      state.memberCSVUploadApprovalQueue.rows.push(Row)
    } else {
      state.memberCSVUploadApprovalQueue.rows.splice(index, 1, Row)
    }
  },
  [types.MEMBERSHIP_UPDATE_CSV_ROW_ON_APPROVAL_QUEUE](state, { uuid, field, value }) {
    let index = _.findIndex(state.memberCSVUploadApprovalQueue.rows, { uuid: uuid })

    if(index > -1)  {
      state.memberCSVUploadApprovalQueue.rows[index][field] = value
    }
  },
  [types.MEMBERSHIP_TOGGLE_INVITE_ON_APPROVAL_QUEUE](state, invited) {
    state.memberCSVUploadApprovalQueue.rows.forEach(row => row.invite = invited)
  },
  [types.MEMBERSHIP_SET_IMPORT_ALL_AS_ON_APPROVAL_QUEUE](state, role) {
    state.memberCSVUploadApprovalQueue.rows.forEach(row => row.role = role)
  },
  [types.MEMBERSHIP_SET_ADD_ALL_TO_ON_APPROVAL_QUEUE](state, groups) {
    state.memberCSVUploadApprovalQueue.rows.forEach(row => row.groups = groups)
  },
  [types.MEMBERSHIP_REMOVE_CSV_ROW_FROM_APPROVAL_QUEUE](state, Row) {
    let index = _.findIndex(state.memberCSVUploadApprovalQueue.rows, { uuid: Row.uuid })

    if (index > -1) {
      console.info('Row removed from queue.')
      state.memberCSVUploadApprovalQueue.splice(index, 1)
    }
  },
  [types.MEMBERSHIP_RESET_CSV_APPROVAL_QUEUE](state) {
    console.info('Queue reset.')
    state.memberCSVUploadApprovalQueue = {
      rows: [],
    }
  },
  [types.MEMBERSHIP_QUEUE_APPROVAL_FOR_ACCESS_REQUEST](state, PendingAccessRequest) {
    let index = _.findIndex(state.accessRequestApprovalQueue, { uuid: PendingAccessRequest.uuid })

    if (index === -1) {
      state.accessRequestApprovalQueue.push(PendingAccessRequest)
    }
  },
  [types.MEMBERSHIP_REMOVAL_APPROVAL_FOR_ACCESS_REQUEST](state, PendingAccessRequest) {
    let existingRecord = _.findIndex(state.accessRequestApprovalQueue, { uuid: PendingAccessRequest.uuid })

    if (existingRecord > -1) {
      state.accessRequestApprovalQueue.splice(existingRecord, 1)
    }
  },
  [types.MEMBERSHIP_SET_MEMBERSHIP_GROUPS](state, MembershipGroups) {
    state.membershipGroups = MembershipGroups
  },
  [types.MEMBERSHIP_SET_PENDING_ACCESS_REQUESTS](state, PendingAccessRequests) {
    state.pendingAccessRequests = PendingAccessRequests
  },
  [types.MEMBERSHIP_REMOVE_GROUP_FROM_PENDING_ACCESS_REQUEST](state, Data) {
    let AccessRequest = _.find(state.pendingAccessRequests.data, { uuid: Data.accessRequest.uuid })
    if (!AccessRequest) {
      return
    }
    let index = _.findIndex(AccessRequest.membership.membershipGroups.data, Data.group)
    if (index > -1) {
      AccessRequest.membership.membershipGroups.data.splice(index, 1)
    }
  },
  [types.MEMBERSHIP_UPDATE_PENDING_ACCESS_REQUEST_GROUPS](state, Data) {
    let AccessRequest = _.find(state.pendingAccessRequests.data, { uuid: Data.accessRequest.uuid })
    if (!AccessRequest) {
      return
    }
    AccessRequest.membership.membershipGroups.data = Data.groups
  },
  [types.MEMBERSHIP_REJECT_PENDING_ACCESS_REQUEST](state, AccessRequest) {
    let index = _.findIndex(state.pendingAccessRequests.data, { uuid: AccessRequest.uuid })
    if (index > -1) {
      state.pendingAccessRequests.data.splice(index, 1)
    }
  },
  [types.MEMBERSHIP_RESET_PENDING_ACCESS_REQUEST_QUEUE](state) {
    state.accessRequestApprovalQueue = []
  },
  [types.MEMBERSHIP_OPEN_CREATE_MEMBERSHIP_GROUP_MODAL](state) {
    state.createMembershipGroupModal.open = true
  },
  [types.MEMBERSHIP_CLOSE_CREATE_MEMBERSHIP_GROUP_MODAL](state) {
    state.createMembershipGroupModal.open = false
  },
  [types.MEMBERSHIP_SET_MEMBERSHIP_GROUP_TYPES](state, MembershipGroupTypes) {
    state.membershipGroupTypes = MembershipGroupTypes
  },
  [types.MEMBERSHIP_OPEN_ADD_MEMBERS_TO_MEMBERSHIP_GROUP_MODAL](state, MembershipGroup) {
    state.addMembersToMembershipGroupModal.open = true
    state.addMembersToMembershipGroupModal.membershipGroup = MembershipGroup
  },
  [types.MEMBERSHIP_CLOSE_ADD_MEMBERS_TO_MEMBERSHIP_GROUP_MODAL](state) {
    state.addMembersToMembershipGroupModal.open = false
    state.addMembersToMembershipGroupModal.membershipGroup = null
  },
  [types.MEMBERSHIP_OPEN_EDIT_MEMBERSHIP_GROUP_MODAL](state, MembershipGroup) {
    state.editMembershipGroupModal.open = true
    state.editMembershipGroupModal.membershipGroup = MembershipGroup
  },
  [types.MEMBERSHIP_CLOSE_EDIT_MEMBERSHIP_GROUP_MODAL](state) {
    state.editMembershipGroupModal.open = false
    state.editMembershipGroupModal.membershipGroup = null
  },
  [types.MEMBERSHIP_OPEN_DELETE_MEMBERSHIP_GROUP_MODAL](state, MembershipGroup) {
    state.deleteMembershipGroupModal.open = true
    state.deleteMembershipGroupModal.membershipGroup = MembershipGroup
  },
  [types.MEMBERSHIP_CLOSE_DELETE_MEMBERSHIP_GROUP_MODAL](state) {
    state.deleteMembershipGroupModal.open = false
    state.deleteMembershipGroupModal.membershipGroup = null
  },
  [types.MEMBERSHIP_OPEN_UPLOAD_MEMBER_CSV_MODAL](state) {
    state.uploadMemberCSVModal.open = true
  },
  [types.MEMBERSHIP_CLOSE_UPLOAD_MEMBER_CSV_MODAL](state) {
    state.uploadMemberCSVModal.open = false
  },
  [types.MEMBERSHIP_SET_MEMBERSHIPS](state, Memberships) {
    state.memberships = Memberships
  },
  [types.MEMBERSHIP_SET_MEMBERSHIP](state, Membership) {
    state.membership = Membership
  },
  [types.MEMBERSHIP_OPEN_REMOVE_MEMBERSHIP_FROM_MEMBERSHIP_GROUP_MODAL](state, params) {
    state.removeMembershipFromMembershipGroupModal.membershipUuid = params.membershipUuid
    state.removeMembershipFromMembershipGroupModal.membershipGroup = params.membershipGroup
    state.removeMembershipFromMembershipGroupModal.open = true
  },
  [types.MEMBERSHIP_CLOSE_REMOVE_MEMBERSHIP_FROM_MEMBERSHIP_GROUP_MODAL](state) {
    state.removeMembershipFromMembershipGroupModal.membershipUuid = null
    state.removeMembershipFromMembershipGroupModal.membershipGroup = null
    state.removeMembershipFromMembershipGroupModal.open = false
  },
  [types.MEMBERSHIP_OPEN_DEACTIVATE_MEMBERSHIP_MODAL](state, Membership) {
    state.deactivateMembershipModal.membership = Membership
    state.deactivateMembershipModal.open = true
  },
  [types.MEMBERSHIP_CLOSE_DEACTIVATE_MEMBERSHIP_MODAL](state) {
    state.deactivateMembershipModal.membership = null
    state.deactivateMembershipModal.open = false
  },
  [types.MEMBERSHIP_OPEN_REACTIVATE_MEMBERSHIP_MODAL](state, Membership) {
    state.reactivateMembershipModal.membership = Membership
    state.reactivateMembershipModal.open = true
  },
  [types.MEMBERSHIP_CLOSE_REACTIVATE_MEMBERSHIP_MODAL](state) {
    state.reactivateMembershipModal.membership = null
    state.reactivateMembershipModal.open = false
  },
  [types.MEMBERSHIP_OPEN_DELETE_MEMBERSHIP_MODAL](state, Membership) {
    state.deleteMembershipModal.membership = Membership
    state.deleteMembershipModal.open = true
  },
  [types.MEMBERSHIP_CLOSE_DELETE_MEMBERSHIP_MODAL](state) {
    state.deleteMembershipModal.membership = null
    state.deleteMembershipModal.open = false
  },
  [types.MEMBERSHIP_OPEN_INVITE_MEMBERSHIP_MODAL](state, Membership) {
    state.inviteMembershipModal.membership = Membership
    state.inviteMembershipModal.open = true
  },
  [types.MEMBERSHIP_CLOSE_INVITE_MEMBERSHIP_MODAL](state) {
    state.inviteMembershipModal.membership = null
    state.inviteMembershipModal.open = false
  },
  [types.MEMBERSHIP_START_RUNNING_MEMBERSHIP_REPORT](state) {
    state.membershipReports.running = true
  },
  [types.MEMBERSHIP_STOP_RUNNING_MEMBERSHIP_REPORT](state) {
    state.membershipReports.running = false
  },
  [types.MEMBERSHIP_SET_MEMBERSHIP_REPORTS](state, data) {
    state.membershipReports.data = data
  },
  [types.MEMBERSHIP_SET_AVAILABLE_REPORT_COLUMNS](state, data) {
    state.membershipReports.availableColumns = data
  },
  [types.MEMBERSHIP_SET_AVAILABLE_REPORT_FILTERS](state, data) {
    state.membershipReports.availableFilters = data
  },
  [types.MEMBERSHIP_SET_MEMBERSHIP_REPORT](state, data) {
    state.membershipReport = data
  },
  [types.MEMBERSHIP_TOGGLE_SELECTED_MEMBERSHIP](state, membership) {
    const index = state.selectedMemberships.findIndex(({ uuid }) => uuid === membership.uuid)
    if (index > -1) {
      state.selectedMemberships.splice(index, 1)
    } else {
      state.selectedMemberships.push(membership)
    }
  },
  [types.MEMBERSHIP_TOGGLE_ALL_SELECTED_MEMBERSHIPS](state, { memberships, toggleType }) {
    memberships.forEach((membership) => {
      const index = state.selectedMemberships.findIndex(({ uuid }) => uuid === membership.uuid)

      if (toggleType === 'add') {
        if (index === -1) {
          state.selectedMemberships.push(membership)
        }
      } else {
        if (index > -1) {
          state.selectedMemberships.splice(index, 1)
        }
      }
    })
  },
}

export default {
  state,
  mutations,
}